import { createFileRoute } from '@tanstack/react-router'
import Privacy from 'pages/site/privacy'

export const Route = createFileRoute('/site/privacy')({
   head: () => ({
      meta: [{ title: 'Privacy Policy' }, { name: 'robots', content: 'noindex' }],
   }),
   component: Privacy,
})
